export default "__VITE_ASSET__f2c6c0c6__"